import { create } from 'zustand';

type ConnectModalState = {
	isOpen: boolean;
	open: () => void;
	close: () => void;
	setOpen: (open: boolean) => void;
};

export const useWalletConnectModalStore = create<ConnectModalState>((set) => ({
	isOpen: false,
	open: () => set({ isOpen: true }),
	close: () => set({ isOpen: false }),
	setOpen: (open) => set({ isOpen: open }),
}));
